var map = {
	"./close.svg": 4238,
	"./correct.svg": 5268,
	"./download.svg": 5674,
	"./edit.svg": 4806,
	"./login.svg": 5665,
	"./next.svg": 7209,
	"./pdf.svg": 4380,
	"./popup-edit/active.svg": 5690,
	"./popup-edit/default.svg": 9179,
	"./prev.svg": 4489,
	"./qr.svg": 4191,
	"./remove.svg": 9438,
	"./search.svg": 7138,
	"./update.svg": 5261,
	"./upload.svg": 1897,
	"./wrong.svg": 2409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 916;